import { render, staticRenderFns } from "./UserDataVerification.vue?vue&type=template&id=000bd6cb&"
import script from "./UserDataVerification.vue?vue&type=script&lang=js&"
export * from "./UserDataVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('000bd6cb')) {
      api.createRecord('000bd6cb', component.options)
    } else {
      api.reload('000bd6cb', component.options)
    }
    module.hot.accept("./UserDataVerification.vue?vue&type=template&id=000bd6cb&", function () {
      api.rerender('000bd6cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/advanced/aSignApi/UserDataVerification.vue"
export default component.exports